import React from 'react';
import { useTheme } from '../ThemeContext';
import { summarizeAgentActivity } from '../shared/agentActivity';
import ClientDashboardV3 from './ClientDashboardV3';
import FriendJoin from './FriendJoin';
import AgentHome from './AgentHome';
import HomeownerPaywall from './HomeownerPaywall';

const DAY = 24 * 60 * 60 * 1000;

if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (String(url).indexOf('/.netlify/functions/homeowner-client') !== -1) {
      return Promise.resolve(new Response(JSON.stringify({
        agent: {
          first_name: 'Ada',
          last_name: 'Nguyen',
          email: 'ada@example.com',
          phone: '3862590744',
          brokerage: 'Harbor Realty',
          team_name: 'Harbor Team',
        },
        client: {},
      }), { status: 200, headers: { 'Content-Type': 'application/json' } }));
    }
    if (String(url).indexOf('/.netlify/functions/') !== -1) {
      return Promise.resolve(new Response(JSON.stringify({
        data: [],
        folders: [],
        audience: 'sponsored',
        homes: [],
        plan: { entitled: true },
      }), { status: 200, headers: { 'Content-Type': 'application/json' } }));
    }
    return nativeFetch(input, init);
  };
}

function ago(days) {
  return new Date(Date.now() - days * DAY).toISOString();
}

function previewActivity() {
  return summarizeAgentActivity({
    clicks: [
      { click_type: 'phone', clicked_at: ago(2), vendor_id: 'v1', vendor_name: 'Harbor Plumbing' },
      { click_type: 'email', clicked_at: ago(4), vendor_id: 'v2', vendor_name: 'Oak Street Electric' },
    ],
    clients: [
      { id: 'c1', first_name: 'Maya', last_name: 'Chen', status: 'active', agent_id: 'preview', last_active: ago(1), created_at: ago(12) },
    ],
    tasks: [
      { completed: true, completed_at: ago(2), client_id: 'c1', client_name: 'Maya Chen' },
      { completed: true, completed_at: ago(3), client_id: 'c1', client_name: 'Maya Chen' },
    ],
    projects: [{ tasks: [{ completed: true }], updated_at: ago(5) }],
    reports: [],
    shares: [],
    transfers: [],
  }, 'month');
}

const client = {
  id: 'preview-home',
  email: 'jordan@example.com',
  first_name: 'Jordan',
  last_name: 'Lee',
  has_password: true,
  tutorial_completed: true,
  password_hash: 'saved',
  password_reset_required: false,
  address: '12 Palm Ave',
  city: 'DeBary',
  state: 'FL',
  features: [],
};

const link = {
  inviterFirstName: 'Jordan',
  agentFirstName: 'Ada',
  agentActive: true,
  choices: ['sponsor', 'own'],
};

const requests = [
  {
    id: 'preview-request',
    name: 'Sam Rivera',
    email: 'sam@example.com',
    phone: '4075550100',
  },
];

function previewParams() {
  return new URLSearchParams(window.location.search);
}

function screenName() {
  return previewParams().get('screen') || 'join';
}

export default function InviteFriendPreview() {
  const { colors } = useTheme();
  const screen = screenName();
  if (screen === 'menu') {
    return (
      <ClientDashboardV3
        client={client}
        userId="preview-home"
        onLogout={() => {}}
        initialTab="settings"
      />
    );
  }
  if (screen === 'share') {
    return (
      <ClientDashboardV3
        client={client}
        userId="preview-home"
        onLogout={() => {}}
        initialTab="settings"
        initialMorePane="invite"
        invitePreview={{ url: 'https://app.pacarion.com/join?ref=previewtokenpreviewtoken', sheet: true }}
      />
    );
  }
  if (screen === 'agent') {
    return (
      <div style={{ minHeight: '100vh', background: colors.background, color: colors.text, padding: '1.25rem' }}>
        <AgentHome
          activity={previewActivity()}
          period="month"
          onPeriod={() => {}}
          onBilling={() => {}}
          onAddCustomer={() => {}}
          onAddVendor={() => {}}
          onOpenRecord={() => {}}
          requests={requests}
          onAcceptRequest={() => {}}
          onDeclineRequest={() => {}}
        />
      </div>
    );
  }
  const native = previewParams().get('native') === '1';
  if (screen === 'inactive') {
    return (
      <HomeownerPaywall
        native
        plan={{ reason: 'unpaid', entitled: false }}
      />
    );
  }
  const view = screen === 'pending' || screen === 'declined' ? screen : 'choices';
  return (
    <FriendJoin
      token="previewtokenpreviewtoken"
      initialView={view}
      initialLink={link}
      native={native}
    />
  );
}
